import React from "react";
import NsFileUploader from "../../../../components/fields/NsFileUploader";
import NsField from "../../../../components/fields/NsField";
import {Button, Modal} from "react-bootstrap";
import Translate from "../../../../components/Translate";

export default function ModalDocumentoKpiView({
                                                  files,
                                                  setFiles,
                                                  show,
                                                  handleClose,
                                                  translate,
                                                  descrizione,
                                                  setDescrizione,
                                                  idTipoImport,
                                                  idDocumento,
                                                  url,
                                                  handlePostDocumento,
                                                  handleDeleteDocumento,
                                                  onClickSalva,
                                          }) {

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            size={"lg"}
            keyboard={false}
        >
            <Modal.Header
                className={'ns-modal-header'}
                closeVariant='white'
                closeButton>
                <Modal.Title>{translate('Upload Documenti KPI')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form className="row g-3">
                    <div className="col-md-12">
                        <NsField
                            name={"descrizione"}
                            label={"Descrizione:"}
                            valoreNoFormik={descrizione}
                            onChange={event => setDescrizione(event.target.value)}
                        />
                    </div>
                    <div className="col-md-12">
                        <NsFileUploader
                            files={files}
                            setFiles={setFiles}
                            allowMultiple={false}
                            allowRevert={true}
                            endpointPost={url + '?descrizione=' + descrizione + '&id_tipo_imp_dati=' + idTipoImport}
                            endpointDelete={url}
                            handlerPost={handlePostDocumento}
                            handlerDelete={handleDeleteDocumento}
                        />
                    </div>
                </form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <Translate>Annulla</Translate>
                </Button>
                <Button disabled={!idDocumento} variant="primary" onClick={onClickSalva}>
                    <Translate>Salva</Translate>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}